import {inject, Injectable} from '@angular/core';
import {ProductCardApiService} from "../../../../services-api/product-card-api.service";
import {BaseModalApiService} from "../../../../../../../core/components/modals/services/base-modal-api.service";
import {RecordTableApiService} from "../../../../../../../core/services-api/record-table-api.service";
import {GetDataInModalParams} from "../../../../types/product-card-modals.types";
import {websiteLinksResourceType} from "../configs/mb-website-links-modal-config";
import {CreateWebsiteLinkData, WebsiteLinkData} from "../types/mb-website-links-modal.types";

@Injectable({
  providedIn: 'root'
})
export class MbWebsiteLinksModalService {
  private productCardApiService: ProductCardApiService = inject(ProductCardApiService);
  private baseModalApiService: BaseModalApiService = inject(BaseModalApiService);
  private recordTableApiService: RecordTableApiService = inject(RecordTableApiService);

  public setDataInModalParams(parentId: number): GetDataInModalParams {
    return {
      path: websiteLinksResourceType.path,
      queryParams: { marketingBlockId: parentId }
    };
  }

  public getDataInModal<T>(getDataInModalParams: GetDataInModalParams): Promise<Array<T>> {
    return new Promise((resolve, reject) => {
      this.productCardApiService.fetchDataInModal<T>(getDataInModalParams).subscribe({
        next: (data) => resolve(data),
        error: (error) => reject(error)
      });
    });
  }

  public createData(createWebsiteLinkData: CreateWebsiteLinkData): Promise<WebsiteLinkData> {
    return new Promise((resolve, reject) => {
      this.baseModalApiService.createDataInModal<CreateWebsiteLinkData, WebsiteLinkData>(createWebsiteLinkData, websiteLinksResourceType.path).subscribe({
        next: (data) => resolve(data),
        error: (error) => reject(error)
      });
    });
  }

  public deleteRecord(recordId: number): Promise<void> {
    return new Promise((resolve, reject) => {
      this.recordTableApiService.deleteRecord(websiteLinksResourceType.path, recordId).subscribe({
        next: () => resolve(),
        error: (error) => reject(error)
      });
    });
  }
}
